<template>
  <v-menu
    bottom
    offset-y
    nudge-bottom="5"
    v-model="actionType"
    max-height="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-on="on" v-bind="attrs" v-if="typeContent">
        <v-icon left small>mdi-{{ typeContent.icon }}</v-icon>
        {{ typeContent.name }}
        <v-fade-transition mode="out-in">
          <v-icon class="ms-2" key="down" v-if="!actionType"
            >mdi-chevron-down</v-icon
          >
          <v-icon class="ms-2" key="up" v-else>mdi-chevron-up</v-icon>
        </v-fade-transition>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-for="(item, i) in itemsType"
        :key="i"
        color="primary"
        @click="selectItem(item.value)"
      >
        <v-list-item-icon>
          <v-icon>mdi-{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "all",
    },
  },
  data() {
    return {
      actionType: false,
      itemsType: [{ name: "مدل کیوآر", value: "all", icon: "filter" }],
    };
  },
  mounted() {
    this.itemsType = this.itemsType.concat(this.getQrTypes());
  },
  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        if (val !== this.value) {
          this.$emit("input", val);
        }
      },
    },
    typeContent() {
      return this.itemsType.find(
        (item) => item.value.toLowerCase() === this.valueComputed?.toLowerCase()
      );
    },
  },
  watch: {
    value(newVal) {},
  },
  methods: {
    selectItem(val) {
      this.valueComputed = val;
      this.actionType = false;
    },
  },
};
</script>

<style scoped></style>
